import { CheckoutError, type PaymentOutcome } from './payment-checkout';

type Analytics = {
  track(event: string, params: Record<string, unknown>): void;
  once(key: string, event: string, params: Record<string, unknown>): void;
};
/** The checkout must resolve only after backend verification. Cancellation never earns revenue. */
export async function observePayment(
  params: { transaction_id: string; currency: string; value: number; [key: string]: unknown },
  open: (failed: () => void) => Promise<PaymentOutcome>,
  analytics: Analytics,
): Promise<PaymentOutcome> {
  analytics.track('begin_checkout', params);
  try {
    const outcome = await open(() =>
      analytics.track('payment_failed', { ...params, reason: 'provider_declined' }),
    );
    if (outcome === 'paid') analytics.once(`purchase:${params.transaction_id}`, 'purchase', params);
    else if (outcome === 'dismissed') analytics.track('checkout_cancelled', params);
    return outcome;
  } catch (error) {
    analytics.track(
      error instanceof CheckoutError && error.paymentReceived
        ? 'payment_verification_pending'
        : 'checkout_failed',
      {
        ...params,
        reason:
          error instanceof CheckoutError && error.paymentReceived ? 'verification_pending' : 'request_failed',
      },
    );
    throw error;
  }
}
